import type { GetMaintenanceCategoriesInput, MaintenanceCategoryCreateDto, MaintenanceCategoryDto, MaintenanceCategoryUpdateDto, MaintenanceCategoryWithNavigationPropertiesDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceCategoryService {
  apiName = 'Inventory';

  create = (input: MaintenanceCategoryCreateDto) =>
    this.restService.request<any, MaintenanceCategoryDto>({
      method: 'POST',
      url: '/api/inventory/maintenance-categories',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/maintenance-categories/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, MaintenanceCategoryDto>({
      method: 'GET',
      url: `/api/inventory/maintenance-categories/${id}`,
    },
    { apiName: this.apiName });

  getLegalDocumentLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/maintenance-categories/legal-document-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getList = (input: GetMaintenanceCategoriesInput) =>
    this.restService.request<any, PagedResultDto<MaintenanceCategoryWithNavigationPropertiesDto>>({
      method: 'GET',
      url: '/api/inventory/maintenance-categories',
      params: { filterText: input.filterText, name: input.name, description: input.description, procedureId: input.procedureId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, MaintenanceCategoryWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/inventory/maintenance-categories/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });

  update = (id: string, input: MaintenanceCategoryUpdateDto) =>
    this.restService.request<any, MaintenanceCategoryDto>({
      method: 'PUT',
      url: `/api/inventory/maintenance-categories/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
